import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {Payday} from "../Payday";
import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {ResetClaws} from "../runnerpresentations/ResetClaws";
import {LocalPresentation} from "../runnerpresentations/LocalPresentation";

export class PaydayBetPresentation implements FlowStatePresentation {

    presentations:SimplePresentation[] = [
        new ResetClaws(),
        new LocalPresentation(
            (controller:SimplePresentationRunnerController) => this.spin(controller),
            () => true,
            "Normal Bet")
    ];

    constructor() {}

    public start(flowStateController:FlowStateController) {
        SimplePresentationRunner.run(this.presentations,
                                     () => flowStateController.finish(),
                                     (callback?:Function) => flowStateController.setSkipCallback(callback),
                                     "NormalBet");
    }

    spin(controller:SimplePresentationRunnerController) {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            const sounds = ["reelsSpinning", "reelsSpinning2", "reelsSpinning3"]
            const index = Math.floor(Math.random() * 3);
            Payday.soundPlayer.playLoopingSound(sounds[index]);
        })
        tl.add(Payday.reelView.reel.start());
        tl.add(Payday.reelView.startConveyorBelts(), '<')

        tl.add(() => { controller.finish() });
    }
}